module.exports = __webpack_public_path__ + "img/img50.92bbc3e2.svg";